// 애플리케이션 설정 상수
export const APP_CONFIG = {
  // 치과 이름 (환경변수 우선, 없으면 기본값 사용)
  CLINIC_NAME: process.env.REACT_APP_CLINIC_NAME || '바른이치',

  // 애플리케이션 이름 (환경변수 우선, 없으면 기본값 사용)
  APP_NAME: process.env.REACT_APP_NAME || 'DentFlow',

  // 전체 애플리케이션 제목 (환경변수 우선, 없으면 동적 생성)
  get FULL_APP_NAME() {
    return process.env.REACT_APP_FULL_NAME || `${this.CLINIC_NAME} ${this.APP_NAME}`;
  }
} as const;

// 기타 설정
export const UI_CONFIG = {
  // 사이드바 설정
  SIDEBAR_WIDTH: 'w-44',
  
  // 색상 테마
  PRIMARY_COLOR: 'blue',
  
  // 날짜 형식
  DATE_FORMAT: 'ko-KR'
} as const; 